import { canCreateOrUpdate } from './validators/functions/can-create-or-update.function';
import { canPerformAction } from './validators/functions/can-perform-action.function';

export * from './dtos/create-vehicle-road-worthy-check.dto';
export * from './dtos/update-vehicle-road-worthy-check.dto';
export * from './dtos/vehicle-road-worthy-check-links.dto';
export * from './dtos/vehicle-road-worthy-check-list.dto';
export * from './dtos/vehicle-road-worthy-check-record.dto';
export * from './dtos/vehicle-road-worthy-check-activity-event.dto';
export * from './dtos/vehicle-road-worthy-check-activity-event-hydration.dto';
export * from './dtos/vehicle-road-worthy-check-search.dto';
export * from './dtos/vehicle-road-worthy-checks-stats.dto';

export * from './enums/vehicle-road-worthy-check-record-category.enum';
export * from './enums/vehicle-road-worthy-check-status.enum';
export * from './enums/vehicle-road-worthy-check-action.enum';

export * from './functions/vehicle-road-worthy-check-status-to-color.function';

export * from './types/vehicle-road-worthy-checks-filters';

export * from './validators/schemas/create-vehicle-road-worthy-check.schema';
export * from './validators/schemas/update-vehicle-road-worthy-check.schema';

export const vehicleRoadWorthyCheckValidators = {
  canCreateOrUpdate,
  canPerformAction,
};
